/**
 * Cierre de sesión por inactividad (frontend). Debe coincidir en todos los módulos autenticados.
 */
export const INACTIVITY_LOGOUT_MS = 15 * 60 * 1000;

/**
 * Tras esta inactividad acumulada empiezan los avisos (solo notificación de sistema + cuenta atrás interna).
 */
export const SESSION_WARNING_FIRE_MS = 10 * 60 * 1000;

/**
 * Tiempo restante hasta el logout cuando arranca el aviso: INACTIVITY_LOGOUT_MS − SESSION_WARNING_FIRE_MS.
 */
export const SESSION_WARNING_BEFORE_MS = INACTIVITY_LOGOUT_MS - SESSION_WARNING_FIRE_MS;

/** Texto del cierre por inactividad (coherente con `INACTIVITY_LOGOUT_MS`). */
export function getInactivityLogoutUserMessage() {
  const min = Math.max(1, Math.round(INACTIVITY_LOGOUT_MS / 60000));
  return `Sesión finalizada por inactividad de ${min} minuto${min === 1 ? '' : 's'}`;
}
